module.exports = __webpack_public_path__ + "static/img/school.ee9b3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school.png
// module id = h9qT
// module chunks = 1